import styled from "styled-components";
import { Link } from "react-router-dom";
export const CollectionListContainer = styled.div`
  margin: auto;
  width: 80%;
  min-height: 10vh;
  margin-top: 5rem;
  @media (max-width: 768px) {
    width: 100%;
    padding: 0rem;
    height: auto;
  }
`;
export const Heading = styled.h1`
  color: #fff;
  font-size: 3.2rem;
  line-height: 4rem;
  font-weight: 900;
  font-family: Poppins;
  @media (max-width: 768px) {
    line-height: 3rem;
    font-size: 2.2rem;
  }
`;
export const SubHeading = styled.h3`
  color: #fff;
  text-align: center;
  line-height: 3rem;
  font-size: 1.3rem;
  font-family: Poppins;
  line-height: 1rem;
  font-weight: 500;
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;
export const ListCard = styled.div`
  display: flex;
  background: #fff;
  box-shadow: 0px 1px 6px #00000024;
  border-radius: 1rem;
  margin: 1.2rem 0rem;
  overflow: hidden;
  height: 9.4rem !important;
  flex-direction: row;
  width: 30%;

  @media (max-width: 768px) {
    height: auto;
    min-height: 7rem;
    margin: 0rem 0rem 0.5rem 0rem;
    width: 100% !important;
  }
`;

export const BannerContainer = styled.div`
  position: relative;
  z-index: 0;
  padding: 4rem 0rem;
  &:before {
    content: "/";
    position: absolute;
    width: 100%;
    z-index: 0 !important;
    min-height: 40vh;
    left: 10%;
    margin-top: 0rem;
    width: 80%;
    border-radius: 0rem 0rem 1rem 1rem;
    background: url(../../gbetbackground.jpeg);
    background-color: rgba(0, 0, 0, 0.4);
    background-size: cover;
    box-shadow: inset 0 0 0 200px rgb(0, 0, 0, 0.77);
    filter: blur(3px);
    @media (max-width: 768px) {
      width: 100% !important;
      left: 0%;
      min-height: 45vh;
    }
    @media (min-width: 1400px) {
      box-shadow: inset 0 0 0 4000rem rgb(0, 0, 0, 0.77) !important;
    }
  }
`;
export const TextContainer = styled.div`
  z-index: 10;
  position: absolute;
  padding: 4rem 0rem;
  text-align: center;
  left: 50%;
  transform: translate(-50%, 0);
  width: 80%;
  h5 {
    color: #fff;
    font-weight: 400;
    font-size: 1.3rem;
    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }
  @media (max-width: 768px) {
    width: 95%;
    padding: 1rem 0rem;
  }
`;
export const Container = styled.div`
  min-height: 40vh;
  width: 100%;
  display: block;
`;
export const Collections = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  background: #f7f7f7;
  border-radius: 1.5rem;
  padding: 1.5rem 0rem;
  @media (max-width: 768px) {
    padding: 0rem;
  }
`;
export const CollectionDetail = styled.div`
  width: 60%;
  padding: 0rem 1rem;
`;
export const ImageContainer = styled.div`
  padding: 0.3rem;
  cursor: pointer;
  width: 40%;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.8;
    border-radius: 0.6rem;
    &:hover {
      opacity: 1;
    }
  }
`;
export const SyledCollectionLink = styled(Link)`
  color: #fff;
  border-radius: 1.5rem;
  padding: 0.6rem 1rem;
  background: #393939;
`;
export const StyledHeading = styled(Heading)`
  font-size: 2rem;
  @media (max-width: 450px) {
    font-size: 1.5rem;
  }
`;
export const CollectionHeading = styled(Heading)`
  font-size: 1.2rem;
  line-height: 2rem;
  color: #393939;
  @media (max-width: 500px) {
    font-size: 1.1rem;
  }
`;
